import { Link } from "react-router-dom";
import {
  Globe,
  Trophy,
  Users,
  Zap,
  Gamepad2,
  Video,
  DollarSign,
  ArrowRight,
  Plus,
} from "lucide-react";
import "../styles/about.css";
import { useAuth } from "../../../../common/store/authStore";

function AboutSection() {
  const { authenticatedUser } = useAuth();
  const isAuthenticated = !!authenticatedUser;

  const features = [
    {
      icon: <Trophy size={24} />,
      title: "Tournament Hosting",
      description:
        "Create and manage tournaments with custom rules, brackets, and prize pools.",
      color: "#FFD700",
    },
    {
      icon: <Users size={24} />,
      title: "Community Building",
      description:
        "Connect with gamers across Africa and build your gaming network.",
      color: "#ff0000",
    },
    {
      icon: <Video size={24} />,
      title: "Live Streaming",
      description:
        "Stream your gameplay and tournaments to engage with your audience.",
      color: "#FFD700",
    },
    {
      icon: <DollarSign size={24} />,
      title: "Earn Rewards",
      description: "Win prizes, earn money, and build your gaming career.",
      color: "#ff0000",
    },
    {
      icon: <Gamepad2 size={24} />,
      title: "Multiple Games",
      description:
        "Support for popular games like FIFA, Call of Duty, and more.",
      color: "#FFD700",
    },
    {
      icon: <Globe size={24} />,
      title: "African Focus",
      description: "Built specifically for African gamers and gaming culture.",
      color: "#ff0000",
    },
  ];

  return (
    <section className="about-section">
      <div className="about-container">
        {/* Section Header */}
        <div className="about-header">
          <div className="about-badge">
            <Zap size={16} />
            <span>What We Do</span>
          </div>
          <h2 className="about-title">Reimagining Gaming in Africa</h2>
          <p className="about-subtitle">
            We're building the ultimate gaming ecosystem that connects players,
            hosts tournaments, and creates opportunities for African gamers to
            thrive.
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card"
              style={{ "--feature-color": feature.color } as React.CSSProperties}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="about-cta">
          <div className="cta-content">
            <h3 className="cta-title">Ready to Join the Revolution?</h3>
            <p className="cta-description">
              Start your gaming journey today and become part of Africa's
              fastest-growing gaming community.
            </p>
            {isAuthenticated ? (
              <Link to="/create-tournament" className="cta-button">
                <Plus size={18} stroke="#000" />
                <span>Create Tournament</span>
              </Link>
            ) : (
              <Link to="/sign-up" className="cta-button">
                <span>Get Started Now</span>
                <ArrowRight size={18} stroke="#000" />
              </Link>
            )}
          </div>
          <div className="cta-visual">
            <div className="cta-glow"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
